<template>
     <img :src="require('@/assets/images/dealer/'+type+'.png')" alt="" :style="'width:'+size+'px;'+'height:'+size+'px'"  />
</template>
<script>
export default {
    name:"cIcon",
    props:{
        type:{
            type:String,
            default(){
                return 'fhgl'
            }
        },
        size:{
            type:Number,
            default:function(){
                return 28
            }
        }
    }
}
</script>